import { BaseResponse } from "../../../../../../../types/api/api.types";
import { PROSPECT_ENDPOINTS } from "../../../../../../../utils/api/endpoints/prospectEndpoints";
import { AssignAllProspectsQueryParams } from "./AssignProspectsTable.types";

const PREFIX = '[assignAllProspectsQuery]';

export const ASSIGN_ALL_PROSPECT_QUERY_KEY = 'ASSIGN_ALL_PROSPECTS';

export const assignAllProspectsQuery = async (params: AssignAllProspectsQueryParams) => {
  console.log(PREFIX, `Fetching assign prospect...`);
  const response = await PROSPECT_ENDPOINTS.assignAllProspects(params);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Fetched assign prospect.`);
  return json as BaseResponse;
};